import React, { useState } from "react";
import {
    StepHeading,
    FormBackground,
    FormContainer,
    FormRow,
    FormGroup,
    FormLabel,
    SelectWrapper,
    StyledSelect,
    TextareaWrapper,
    StyledTextarea,
    FormFooter,
    SubmitArea,
    BackLink,
    SubmitButton,
    Spinner,
    BreakWordText,
    BreakDownMobile,
} from "../survey.styled";

export interface ThirdStepFormData {
    ballContact: string;
    biggestMiss: string;
    message: string;
}

interface ThirdStepProps {
    onBack: () => void;
    onSave: (data: ThirdStepFormData) => void;
    isLoading?: boolean;
    error?: string | null;
}

const ThirdStep: React.FC<ThirdStepProps> = ({ onBack, onSave, isLoading = false, error = null }) => {
    const [ballContact, setBallContact] = useState('');
    const [biggestMiss, setBiggestMiss] = useState('');
    const [message, setMessage] = useState('');

    const isValid = ballContact !== '' && biggestMiss !== '' && message.trim() !== '';

    const handleSave = () => {
        if (!isValid) return;
        onSave({ ballContact, biggestMiss, message });
    };

    return (
        <div>
            <StepHeading>
                Tell Your PGA Instructor About Your Game So<BreakWordText /> He<BreakDownMobile /> Can Customize Your Plan
            </StepHeading>
            <FormBackground>
                <FormContainer>
                    <FormRow>
                        <FormGroup>
                            <FormLabel htmlFor="ball-contact">How is your ball contact?*</FormLabel>
                            <SelectWrapper>
                                <StyledSelect
                                    id="ball-contact"
                                    name="ball-contact"
                                    value={ballContact}
                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setBallContact(e.target.value)}
                                >
                                    <option value="">Select...</option>
                                    <option value="Good Contact">Good Contact</option>
                                    <option value="Fat Shots">Fat Shots</option>
                                    <option value="Thin Shots">Thin Shots</option>
                                    <option value="Fat & Thin Shots">Fat &amp; Thin Shots</option>
                                    <option value="Heel Miss">Heel Miss</option>
                                    <option value="Toe Miss">Toe Miss</option>
                                    <option value="I Don't Know">I Don&apos;t Know</option>
                                </StyledSelect>
                            </SelectWrapper>
                        </FormGroup>
                        <FormGroup>
                            <FormLabel htmlFor="biggest-miss">What is your biggest miss?*</FormLabel>
                            <SelectWrapper>
                                <StyledSelect
                                    id="biggest-miss"
                                    name="biggest-miss"
                                    value={biggestMiss}
                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setBiggestMiss(e.target.value)}
                                >
                                    <option value="">Select...</option>
                                    <option value="Push Slice">Push Slice</option>
                                    <option value="Pull Slice">Pull Slice</option>
                                    <option value="Push Hook">Push Hook</option>
                                    <option value="Pull Hook">Pull Hook</option>
                                    <option value="Two Way Miss">Two Way Miss</option>
                                    <option value="Shank">Shank</option>
                                </StyledSelect>
                            </SelectWrapper>
                        </FormGroup>
                    </FormRow>
                    <FormLabel htmlFor="user-message">
                        Tell me about your golf game and where you want to improve?*
                    </FormLabel>
                    <TextareaWrapper>
                        <StyledTextarea
                            id="user-message"
                            name="message"
                            value={message}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value)}
                        />
                    </TextareaWrapper>
                    {error && (
                        <div style={{ color: '#DD4835', fontSize: 14, marginBottom: 12 }}>
                            {error}
                        </div>
                    )}
                    <FormFooter>
                        <BackLink
                            href="#"
                            onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); if (!isLoading) onBack(); }}
                        >
                            Back
                        </BackLink>
                        <SubmitArea>
                            <SubmitButton
                                name="send-message"
                                disabled={!isValid || isLoading}
                                onClick={handleSave}
                            >
                                {isLoading ? (
                                    <Spinner />
                                ) : (
                                    <>Save &amp; Submit</>
                                )}
                            </SubmitButton>
                        </SubmitArea>
                    </FormFooter>
                </FormContainer>
            </FormBackground>
        </div>
    );
};

export default ThirdStep;